// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__KpXKP","overlay__content":"LoadingOverlay_overlay__content__vlezW"};